<template>
<iframe-template
  :src='iframeurl'
  :visible='visible'
  iframe-name='printables-cards'
  width='100%'
  @iframe:loaded="loading=false;dirty=false" >

  <template slot="about" >
    <v-alert type='info' tile v-if='dirty===true' dismissible >
      Click update to apply changes to cards
      <v-btn @click='update' color='primary' class='float-right' >Update</v-btn>
    </v-alert>
  </template>

  <template slot="preferences" >
    <!-- {{members}} -->
    <v-progress-linear indeterminate v-if="loading" />
    <v-card>
      <v-card-title class='py-1 grey lighten-4 overline' >
        Business cards
        <!-- <v-spacer/>
        <v-btn icon small
          :href='url' target='_blank' class='ml-1' >
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn> -->
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <!-- <v-text-field v-model='practitionerId' label='Practitioner ID' /> -->
        <practitioner-picker v-model='selectedPractitioner' :space-id='spaceId' />
        <v-checkbox dense hide-details
          v-model='constrainLogo'
          label='Adjust logo size' />

        <template v-if='constrainLogo' >
          <v-radio-group row v-model="constrainBy" >
            <v-radio label="Constrain by width" value="width" />
            <v-radio label="Constrain by height" value="height" />
          </v-radio-group>
          <v-slider :min='50' :max='100' persistent-hint
            thumb-label="always"
            :hint="logoConstraintLabel"
            v-model='preferences.bgSize' />
        </template>

        <v-subheader class="overline mt-2 pl-0" >Preferences</v-subheader>

        <v-card outlined >
          <v-btn small block outlined tile
            :style="{ color: `rgb(${computedMainColor})` }"
            @click='customizeMainColor=!customizeMainColor' >
            Customize Color
            <v-spacer/>
            <v-icon v-if='customizeMainColor' small >mdi-close</v-icon>
            <v-btn x-small outlined
              v-if="!customizeMainColor && computedMainColor !== '0,0,0'"
              @click.stop='clearColor' >clear</v-btn>
          </v-btn>
          <v-color-picker hide-canvas hide-mode-switch
            v-if='customizeMainColor'
            v-model='mainColor'
            mode='rgba'
            class="ma-2" />
        </v-card>

        <v-card outlined class='mt-2' >
          <v-btn small block outlined tile
            :style="{ color: `rgb(${computedQRColor})` }"
            @click='customizeQRColor=!customizeQRColor' >
            Customize QR Color
            <v-spacer/>
            <v-icon v-if='customizeQRColor' small >mdi-close</v-icon>
            <v-btn x-small outlined
              v-if="!customizeQRColor && computedQRColor !== '0,0,0'"
              @click.stop='clearQRColor' >clear</v-btn>
          </v-btn>
          <v-color-picker hide-canvas hide-mode-switch
            v-if='customizeQRColor'
            v-model='qrColor'
            mode='rgba'
            class="ma-2" />
        </v-card>

        <v-text-field
          clearable persistent-hint
          v-model='preferences.subtitle'
          label='Subtitle'
          hint="Leave blank to use practice number / registration number" />
        <!-- <v-text-field v-model='preferences.qrColor' label='QR code color' /> -->
        <v-text-field
          clearable persistent-hint
          :loading='requests.websites.loading'
          v-model='preferences.websiteText'
          label='Website link'
          placeholder="example.com"
          prefix="https://" />
        <template v-for='site in sites' >
          <v-chip x-small :key='site.id'
            v-if='site.canonical_domain'
            @click='preferences.websiteText = site.canonical_domain.name'
            class='mr-1' >{{site.canonical_domain.name}}</v-chip>
        </template>

        <v-subheader class="overline mt-2 pl-0" >Font size</v-subheader>
        <v-slider thumb-label="always"
          v-model="preferences.size"
          class="align-center mt-10"
          :max="15" :min="6"
          hide-details >
          <template v-slot:append>
            <v-text-field hide-details single-line
              v-model="preferences.size"
              class="mt-0 pt-0"
              type="number"
              style="width: 60px" />
          </template>
        </v-slider>
        <!-- {{url}} -->
      </v-card-text>
      <v-card-actions >
        <v-btn @click='update' color='primary' >Update</v-btn>
        <v-spacer/>
        <v-btn @click='triggerPrint' >Print</v-btn>
      </v-card-actions>
    </v-card>
  </template>
</iframe-template>
</template>
<script>
import IframeTemplate from '@/views/brand/digitalassets/IframeTemplate.vue'
import PractitionerPicker from '@/components/pickers/PractitionerPicker.vue'

export default {
  name: 'Printables',
  components: {IframeTemplate, PractitionerPicker},
  props: {
    spaceId: { required: false },
    members: { type: Array, required: true }
  },
  data () {
    return {
      dirty: false,
      customizeMainColor: false,
      customizeQRColor: false,
      selectedPractitioner: {},
      mainColor: { r: 0, g: 0, b: 0, a: 1 },
      qrColor: { r: 0, g: 0, b: 0, a: 1 },
      loading: false,
      constrainLogo: false,
      constrainBy: 'height',
      preferences: {
        size: 8,
        bgSize: 90,
        subtitle: null,
        websiteText: null
      },
      requests: {
        websites: {
          resource: 'contentguru.websites',
          params: {
            ordering: '-space_id'
          }
        }
      },
      iframeurl: null
    }
  },
  mounted () {
    this.update()
    this.getWebsites()
    this.dirty = false
    // this.loading = true
  },
  methods: {
    update () {
      if (this.url) {
        this.iframeurl = this.url
        this.loading = true
      }
      this.dirty = false
    },
    triggerPrint () {
      // window.frames['printables-cards'].focus()
      // window.frames['printables-cards'].print()
      const iframe = document.getElementById('printables-cards')
      if (!iframe || !iframe.contentWindow) return
      iframe.contentWindow.postMessage({ type: 'PRINT' }, this.iframeurl)
      iframe.contentWindow.postMessage({ type: 'PRINT' }, this.iframeurl)

    },
    clearColor () {
      this.customizeMainColor = false
      this.mainColor = { r:0, g:0, b:0 }
    },
    clearQRColor () {
      this.customizeQRColor = false
      this.qrColor = { r:0, g:0, b:0 }
    },
    getWebsites () {
      this.$request('get', this.requests.websites)
    },
  },
  watch: {
    url () {
      if (this.url && !this.loading) {
        this.dirty = true
      }
    },
    members: {
      immediate: true,
      handler () {
        if (this.members && this.members.length > 0) {
          this.selectedPractitioner = this.members[0]
        }
      }
    },
    customizeMainColor () {
      if (this.customizeMainColor) {
        this.mainColor = { r:255, g:0, b:0 }
      }
    },
    customizeQRColor () {
      if (this.customizeQRColor) {
        this.qrColor = { r:255, g:0, b:0 }
      }
    },
    numSites () {
      if (this.numSites > 0) {
        let site = this.sites[0]
        if (site && site.canonical_domain && this.preferences.websiteText === null) {
          this.preferences.websiteText = site.canonical_domain.name
          this.update()
        }
      }
    }
  },
  computed: {
    visible () {
      if (this.iframeurl) { return true }
      return false
    },
    practitionerId () {
      return this.selectedPractitioner.id
    },
    computedMainColor () {
      let c = this.mainColor
      return `${c.r},${c.g},${c.b}`
    },
    computedQRColor () {
      let c = this.qrColor
      return `${c.r},${c.g},${c.b}`
    },
    url () {
      if (!this.practitionerId) { return null }
      let base = 'https://contentguru.appointmentguru.co'
      // let base = 'http://localhost:8000/'
      let url = `${base}/assets/card/${this.practitionerId}/?color=${this.computedMainColor}&qr_color=${this.computedQRColor}&font_size=${this.preferences.size}&space=${this.spaceId}`
      if (this.constrainLogo) {
        if (this.constrainBy === 'width') {
          url += '&bg_width=' + this.preferences.bgSize
        } else {
          url += '&bg_height=' + this.preferences.bgSize
        }
      }
      if (this.preferences.subtitle) {
        url += '&subtitle=' + this.preferences.subtitle
      }
      if (this.preferences.websiteText) {
        url += '&website_text=' + this.preferences.websiteText
      }
      return url
    },
    logoConstraintLabel () {
      let size = this.preferences.bgSize
      return `Logo will be a maximum of ${size}% of the card's ${this.constrainBy}`
    },
    sites () {
      return this.getObjectPath(this.requests.websites, 'result.results', [])
    },
    numSites () {
      return this.getObjectPath(this.requests.websites, 'result.count', 0)
    }
  }
}
</script>
